import Plot from "react-plotly.js";
import { Button, Icon } from "semantic-ui-react";

const COR_BARRAS = "#37536d";

function GraficoProcessosPorArea({ dados, onExpandir }) {
  const dadosTratados = (dados || []).map((item) => ({
    label: item.label?.trim(),
    valor: item.valor,
  }));
  
  const labels = dadosTratados.map((item) => item.label);
  const values = dadosTratados.map((item) => item.valor);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
        <div />
        {onExpandir && (
          <Button 
            icon 
            size="mini" 
            basic 
            onClick={() => onExpandir(dadosTratados, 'Por Área')}
            title="Ver todas as áreas"
          >
            <Icon name="expand" />
          </Button>
        )}
      </div>
      <Plot
      data={[
        {
          type: "bar",
          x: labels,
          y: values,
          marker: { color: COR_BARRAS },
          text: values.map(String),
          textposition: "auto",
          hoverinfo: "x+y",
        },
      ]}
      config={{
        responsive: true,
        staticPlot: true,
        displayModeBar: false,
      }}
      useResizeHandler={true}
      style={{ width: "100%", height: "280px" }}
      layout={{
        title: {
          text: "<b>POR ÁREA</b>",
          font: {
            family: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
            size: 14,
            color: "#37536d",
          },
        },
        xaxis: {
          tickangle: -45,
          tickfont: { size: 10 },
        },
        yaxis: {
          showgrid: true,
          gridcolor: "#e0e0e0",
        },
        margin: { t: 40, b: 80, l: 40, r: 20 },
      }}
      />
    </div>
  );
}

export default GraficoProcessosPorArea;
